import sendSound from '@/assets/sounds/send.mp3';
import receiveSound from '@/assets/sounds/receive.mp3';

/* Lightweight message sound effects.
   - Send: a snappy upward whoosh played on the user's own send action (always
     allowed because it follows a user gesture).
   - Receive: a warm two-note ding played when a genuinely new incoming message
     arrives via realtime. Browsers gate autoplay behind a prior user gesture;
     we lazily create the Audio node on first interaction so the ding works as
     soon as the user has touched the page. */

let sendEl: HTMLAudioElement | null = null;
let receiveEl: HTMLAudioElement | null = null;

const volume = 0.6;

/** Unlock audio on the first user gesture so receive sounds can autoplay later. */
function ensureEl(which: 'send' | 'receive'): HTMLAudioElement {
  if (which === 'send') {
    if (!sendEl) {
      sendEl = new Audio(sendSound);
      sendEl.volume = volume;
    }
    return sendEl;
  }
  if (!receiveEl) {
    receiveEl = new Audio(receiveSound);
    receiveEl.volume = volume;
  }
  return receiveEl;
}

export function playSendSound() {
  try {
    const el = ensureEl('send');
    el.currentTime = 0;
    void el.play().catch(() => {/* ignore autoplay rejection */});
  } catch {
    /* no-op */
  }
}

export function playReceiveSound() {
  try {
    const el = ensureEl('receive');
    el.currentTime = 0;
    void el.play().catch(() => {/* ignore autoplay rejection */});
  } catch {
    /* no-op */
  }
}

/* Call once on first user interaction to warm the audio elements so the
   browser unlocks playback for later realtime-triggered receive sounds. */
let warmed = false;
export function warmAudio() {
  if (warmed) return;
  warmed = true;
  try {
    ensureEl('send');
    ensureEl('receive');
  } catch {
    /* no-op */
  }
}
